import React from 'react';
import { Avatar } from '@mui/material';

interface IdentityAvatarProps {
  children: React.ReactNode;
}

const IdentityAvatar: React.FC<IdentityAvatarProps> = ({ children }) => (
  <Avatar
    aria-hidden="true"
    sx={{
      width: 36,
      height: 36,
      flexShrink: 0,
      bgcolor: 'action.selected',
      color: 'primary.main',
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: '.02em',
    }}
  >
    {children}
  </Avatar>
);

export default IdentityAvatar;
